import { cache, cacheKey } from "core-server/util/ssrCache";
import { RESOLVE_APP, RESOLVE_APP_ERROR, RESOLVE_APP_SUCCESS } from "core-web/state/models/Application/constants";

import ResolveApp from "core-web/libs/GrebbCommerceAPI/Content/ResolveApp";
import { setFooterState } from "core-web/state/models/Footer/dispatches/setFooterState";
import { setBannerState } from "core-web/state/models/Header/dispatches/setBannerState";
import { setHeaderState } from "core-web/state/models/Header/dispatches/setHeaderState";
import store from "core-web/state/store";

export const resolveApp =
    (url = "", parameters = {}, origin, marketPrefixPath) =>
    async (dispatch, getState) => {
        const { isFetching, currentHref } = getState().application;
        // Since we cannot access window.location.href for sure when SSR rendering,
        // we are doing this fix, accessing the url from the state.
        let resolvedUrl = url;

        if (url === "") {
            resolvedUrl = currentHref;
        }
        if (isFetching) {
            return;
        }

        dispatch({ type: RESOLVE_APP });

        try {
            const response = await cache(
                () => ResolveApp(resolvedUrl, parameters, origin, marketPrefixPath),
                cacheKey(resolvedUrl, parameters, origin, marketPrefixPath),
            );

            const cmsPaths = {};

            if (response.data?.config?.options?.paths?.length > 0) {
                response.data.config.options.paths.forEach(({ type, url }) => {
                    if (type && url) {
                        cmsPaths[type] = url;
                    }
                });
            }

            const config = {
                globalOptions: response.data?.config?.global_options,
                authableTemplates: response.data?.config?.authable_templates,
                myAccount: response.data?.config?.my_account,
                options: {
                    ...response.data?.config?.options,
                    paths: cmsPaths,
                },
            };

            const banner = response.data?.config?.header?.banner;

            const isBannerActive = banner?.activation?.display === "enable" && !!banner?.usps?.length;
            setBannerState(isBannerActive)(dispatch, getState);

            const headerState = response.data?.config?.header;
            setHeaderState(headerState)(dispatch, getState);
            const footerState = response.data?.config?.footer;
            setFooterState(footerState)(dispatch, getState);

            dispatch({
                type: RESOLVE_APP_SUCCESS,
                application: response.data.application,
                config,
                currency: response.data.currency,
                languages: response.data.languages,
                paths: response.data.paths,
                priceGroups: response.data.price_groups,
                defaultPriceList: response.data.default_price_list,
            });

            return response;
        } catch (e) {
            dispatch({ type: RESOLVE_APP_ERROR });
            throw e;
        }
    };

export default (url, parameters, origin, path, currentStore = store) =>
    currentStore.dispatch(resolveApp(url, parameters, origin, path));
